/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Toc Mapping Service
 * @file TocMappingService.js
 * @author Satyaki Bose
 */

import Framework, { BaseService } from '@greenville/framework';
import { AET_STORE_EVENTS, TOC_MAPPING_RESPONSE_SOURCE } from '../common/Constants';
import normalizeTocMappingResponse from '../utils/normalizeTocMappingResponse';

export default class TocMappingService extends BaseService {
  constructor() {
    super(AET_STORE_EVENTS.TOC_MAPPING_REQUESTED, 'tocMappingStatus');
  }

  /**
   * API call for Toc Mapping
   * @param {*} eventName
   * @param {*} eventData
   * @returns {Promise}
   */
  // eslint-disable-next-line class-methods-use-this
  handleEvent(eventName, eventData = {}) {
    const {
      chapters,
      sections = [],
      productModel,
      bookId,
      isLLM = false
    } = eventData;

    const queryParams = `?isLLM=${isLLM}`;
    const endpoint = `/chapter-mapping/${bookId}/${productModel}${queryParams}`;

    return this.getClient('prismv2').post(endpoint, {
      bookId,
      chapters,
      sections
    });
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response) {
    try {
      const normalized = normalizeTocMappingResponse(response, TOC_MAPPING_RESPONSE_SOURCE.PRISM);
      Framework.getStoreRegistry()
        .getStore('prismTocMapping')
        .setTocMapping(normalized);
      Framework.getEventManager().publish(AET_STORE_EVENTS.TOC_MAPPING_COMPLETED, {
        ...response,
        data: normalized
      });
    } catch (error) {
      console.error('Error handling TOC mapping response:', error);
      Framework.getEventManager().publish(AET_STORE_EVENTS.TOC_MAPPING_FAILED, { error: error.message });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    console.error('TOC mapping service failed:', error);
    Framework.getEventManager().publish(AET_STORE_EVENTS.TOC_MAPPING_FAILED, { error: error.message });
  }
}
